module.exports = __webpack_public_path__ + "static/media/27.2df82858.JPG";